import 'core-js/stable'
import Vue from 'vue'
export const eventBus = new Vue();
import 'es6-promise/auto'
import axios from 'axios'
import "vuejs-noty/dist/vuejs-noty.css"
import VueNoty from 'vuejs-noty'
Vue.use(VueNoty)
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import VueLazyload from 'vue-lazyload'
import vSelect from 'vue-select'
import VueInputCalculator from "vue-input-calculator";
Vue.component('vue-input-calculator', VueInputCalculator);
Vue.component('v-select', vSelect)
import "vue-select/src/scss/vue-select.scss";
import VueMaterialTabs from "vue-material-tabs";

Vue.use(VueMaterialTabs);
Vue.use(VueLazyload)
import VueSimpleAlert from "vue-simple-alert";

Vue.use(VueSimpleAlert);
import VueGeolocation from 'vue-browser-geolocation' ;
Vue.use(VueGeolocation);

import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);

import VuePassword from 'vue-password'

Vue.component(VuePassword);

const VueUploadComponent = require('vue-upload-component')
Vue.component('file-upload', VueUploadComponent)

/* import VueUploadComponent from 'vue-upload-component'

Vue.component(VueUploadComponent); */

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
 




window._ = require('lodash');

 /* import Echo from "laravel-echo" */

/* window.Pusher = require('pusher-js');
 window.Echo = new Echo({
    broadcaster: 'pusher',
    key: 'mmm',
   
    cluster: 'eu',
    encrypted: true,
    auth: {
        headers: {
            'Accept':'application/json',
            'Content-Type':'application/json',
         }
      }
    });  */
 





Vue.use(VueAxios, axios)
axios.defaults.baseURL = `${process.env.MIX_APP_URL}/api`
Vue.router = router
Vue.use(VueRouter)
window.Bus=new Vue;



window.moment = require('moment');
window.moment.locale('fr');

import moment from 'moment'

Vue.prototype.moment = moment






import Chat from 'vue-beautiful-chat'
Vue.use(Chat)
import VuexFlash from 'vuex-flash';

Vue.use(VuexFlash);

window.$ = window.jQuery = require('jquery')
window.swal = require('sweetalert');

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)



//date ranhe
import VMdDateRangePicker from "v-md-date-range-picker";

Vue.use(VMdDateRangePicker);
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.config.productionTip = false;

import { Form, HasError, AlertError } from 'vform'

Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)
window.Form = Form;



import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
    color: 'rgb(143, 255, 199)',
    failedColor: 'red',
    height: '3px'
  })

  import Apexcharts from 'apexcharts'
  
  import VueApexCharts from 'vue-apexcharts'
  Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

import "chart.js";
import "hchs-vue-charts";
Vue.use(window.VueCharts);



import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import {
  iconsSet as icons
} from './assets/icons/icons.js'
import store from './store'

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})